import { extractPicUrlValue, extractContentValue, extractAsrContent, replaceChars, delimiter } from "@/utils";

export default class LLMStreamParser {
  constructor() {
    this.temp = [];
    this.rawText = "";
  }

  handleMessage(data) {
    const result = {
      type: "text", // text | image
      content: "",
      imgUrl: "",
      end_asr: false,
    };

    this.rawText += data.answer;

    if (data.answer.trim().length) {
      this.temp.push(data.answer.trim());
    }

    const tempStr = this.temp.join("");
    const lastChar = tempStr.slice(-1);

    if (tempStr.includes("[[END_ASR]]")) {
      result.end_asr = true;
      result.content = extractAsrContent(tempStr);
      this.temp = [];
      return result;
    }

    if (!delimiter.includes(lastChar)) {
      return null;
    }

    this.temp = [];
    if (tempStr.includes("答案源自网络")) {
      return;
    }

    if (tempStr.includes("picUrl")) {
      const imgUrl = extractPicUrlValue(tempStr);
      if (imgUrl) {
        result.type = "image";
        result.imgUrl = imgUrl.replace("http://47.96.187.104:9002", window.location.origin);
      }
      return result;
    }

    if (tempStr.includes("content")) {
      result.type = "text";
      result.content = extractContentValue(tempStr);
      return result;
    }

    result.type = "text";
    result.content = tempStr;
    return result;
  }

  handleWorkflowFinished(finalAnswer) {
    if (this.rawText !== finalAnswer && finalAnswer) {
      let diff = finalAnswer.replace(this.rawText, "");
      diff = replaceChars(diff);
      diff = extractAsrContent(diff);

      return diff;
    }
    return null;
  }
}
